// src/services/permissionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getPermissions = async () => {
  return await axios.get(`${API_URL}/permissions`);
};

const getPermission = async (id) => {
  return await axios.get(`${API_URL}/permissions/${id}`);
};

const createPermission = async (permissionData) => {
  return await axios.post(`${API_URL}/permissions/`, permissionData);
};

const updatePermission = async (id, permissionData) => {
  return await axios.put(`${API_URL}/permissions/${id}`, permissionData);
};

const deletePermission = async (id) => {
  return await axios.delete(`${API_URL}/permissions/${id}`);
};

export default {
  getPermissions,
  getPermission,
  createPermission,
  updatePermission,
  deletePermission,
};
